import {ApiRes} from '../../types/api'
import {API_URL, apiGet} from '../api'
import {IPro} from './getProHistoryList'

export const getProDetail = async (id: string): Promise<ApiRes<IPro[]>> => {
    return await apiGet(API_URL, `admin/pros?page_size=10&current_page=1&user_id=${id}`)
}
